import { render, staticRenderFns } from "./MspRecuperaDatiStrava.vue?vue&type=template&id=db5089d6"
import script from "./MspRecuperaDatiStrava.vue?vue&type=script&lang=js"
export * from "./MspRecuperaDatiStrava.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports